$(function() {
    const parallaxElements = $('.parallax');
    updateParallaxes();

    $(document).on('scroll', function(e) {
        updateParallaxes();
    });

    function updateParallaxes() {
        window.requestAnimationFrame(() => {
            let scrollPosition = parseInt($(document).scrollTop());
            parallaxElements.each(function () {
                let parallaxPosition = parseInt($(this).position().top);
                let backgroundOffset = scrollPosition - (parallaxPosition);
                $(this).find('.background').css('top', backgroundOffset / 2);
            });
        });
    }

    function isIe() {
        const ua = navigator.userAgent;
        return ua.indexOf("MSIE ") > -1 || ua.indexOf("Trident/") > -1;
    }

    if (!isIe()) {
        const resizeObserver = new ResizeObserver(() => updateParallaxes());
        resizeObserver.observe($('.main').get(0));
    }
});
